// extracted by mini-css-extract-plugin
module.exports = {"container":"aghanims_container_2Tsiw","on":"aghanims_on_RSp34","glow":"aghanims_glow_RFqsp","icon":"aghanims_icon_34idW","small":"aghanims_small_3_K35"};